import { getRgFrontendHost } from '@/components/shared/rgfe-api'

export const LoginMixin = {
  computed: {
    redirectHost () {
      const { protocol, hostname, port } = window.location
      const hostPort = port ? `:${port}` : ''
      return `${protocol}//${hostname}${hostPort}`
    },
    rgfeApiHost () {
      return getRgFrontendHost()
    },
    failureRedirect () {
      return `${this.redirectHost}/#/login?success=false`
    },
    successRedirectMFA () {
      return `${this.redirectHost}/#/mfa`
    },
    successRedirectHome () {
      return `${this.redirectHost}/#/`
    }
  }
}
